import Response from '../modules/classes/Response';

class FollowController {
  constructor(apiService) {
    this.apiService = apiService;
  }

  getService() {
    return this.apiService ? this.apiService : apiService;
  }

  async followUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().post(`/follow/${userId}`, {}).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async unfollowUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().delete(`/follow/${userId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getFollowers(userId, page = 1, limit = 20) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/follow/followers/${userId}?page=${page}&limit=${limit}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getFollowing(userId, page = 1, limit = 20) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/follow/following/${userId}?page=${page}&limit=${limit}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async isFollowing(userId) {
    return new Promise((resolve, reject) => {
      this.getService().get(`/users/${userId}/is-following`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getRecentFollowersNotFollowedBack() {
    return new Promise((resolve, reject) => {
      this.getService().get('/follow/recent-followers-not-followed-back').then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async getBlockedUsers() {
    return new Promise((resolve, reject) => {
      this.getService().get('/block/blocked').then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async blockUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().post(`/block/${userId}`, {}).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async unblockUser(userId) {
    return new Promise((resolve, reject) => {
      this.getService().delete(`/block/${userId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }

  async removeFollower(userId) {
    return new Promise((resolve, reject) => {
      this.getService().delete(`/follow/follower/${userId}`).then((res) => {
        resolve(Response.parse(res));
      }).catch((err) => {
        reject(err);
      });
    });
  }
}

const defaultFollowController = new FollowController(null);

export { FollowController, defaultFollowController };
export default FollowController;
